export class scrollbarWidth {
    constructor() {
        this.outer = document.createElement('div');
        this.getWidth();
    }
    getWidth() {
        var _a;
        this.outer.style.visibility = 'hidden';
        this.outer.style.overflow = 'scroll';
        document.body.appendChild(this.outer);
        const inner = document.createElement('div');
        this.outer.appendChild(inner);
        const scrollbarWidth = `${this.outer.offsetWidth - inner.offsetWidth}px`;
        (_a = this.outer.parentNode) === null || _a === void 0 ? void 0 : _a.removeChild(this.outer);
        return scrollbarWidth;
    }
}
